import { cloneDeep, isEmpty } from 'lodash';
import * as types from '../actions/actionTypes';
import { addShipWindowFilterData } from '../../components/Filters/ShipDateFilter/Utils';

const getFilterSpecificData = (data: any) => {
  const uniqueCategories = new Set();
  const uniqueWarehouses = new Set();

  if (isEmpty(data?.items))
    return {
      uniqueCategories: [],
      uniqueWarehouses: [],
      uniqueShipWindows: [],
      shipWindowLabels: {},
    };

  const { uniqueShipWindows, shipWindowLabels } = addShipWindowFilterData(data.items);

  data.items.forEach((itemList: any) => {
    uniqueCategories.add(itemList.category);
    uniqueWarehouses.add(itemList.warehouse);
  });

  return {
    uniqueCategories,
    uniqueWarehouses,
    uniqueShipWindows,
    shipWindowLabels,
  };
};

export default function itemSchedulingReducer(state: any = {}, action: any) {
  switch (action.type) {
    case types.ITEMSLIST_SET:
      const {
        uniqueCategories,
        uniqueWarehouses,
        uniqueShipWindows,
        shipWindowLabels,
      } = getFilterSpecificData(action.itemsList);
      return {
        ...state,
        itemsList: action.itemsList,
        uniqueCategories,
        uniqueWarehouses,
        uniqueShipWindows,
        shipWindowLabels,
      };
    case types.ITEMLIST_UPDATE: {
      const values = action.payload.values;
      const items = cloneDeep(state.itemsList.items);
      if (!items) {
        return { ...state };
      }
      values?.forEach((value: any) => {
        const currentItemIndex = items.findIndex(
          (item: any) =>
            item.itemElectId === value.itemElectId && item.itemNumber === value.itemNumber
        );

        let currentItem = items[currentItemIndex];
        currentItem = {
          ...currentItem,
          ...value,
        };
        items[currentItemIndex] = currentItem;
      });
      const itemsList = cloneDeep(state.itemsList);
      itemsList.items = items;
      // the shipping dates are editable here, so an edit can retag a row and open a new window
      const { uniqueShipWindows, shipWindowLabels } = addShipWindowFilterData(items);
      return { ...state, itemsList, uniqueShipWindows, shipWindowLabels };
    }
    case types.ITEMLIST_DELETE: {
      const itemElectId = action.payload.itemElectId;
      const items = cloneDeep(state.itemsList.items);
      if (!items) {
        return { ...state };
      }
      const newItems = items.filter((item: any) => item.itemElectId !== itemElectId);
      const itemsList = cloneDeep(state.itemsList);
      itemsList.items = newItems;
      const { uniqueShipWindows, shipWindowLabels } = addShipWindowFilterData(newItems);
      return { ...state, itemsList, uniqueShipWindows, shipWindowLabels };
    }
    default:
      return state;
  }
}
